import { SVGProps } from 'react'

export const PersonOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M18.39 15.06c-1.68-.86-3.86-1.56-6.39-1.56s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.72v2.78h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM18 18.5H6v-.78c0-.38.2-.72.52-.88 1.19-.61 3.11-1.34 5.48-1.34 2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88v.78zM12 12.5c2.21 0 4-1.79 4-4V5c0-.83-.67-1.5-1.5-1.5-.52 0-.98.27-1.25.67-.27-.4-.73-.67-1.25-.67s-.98.27-1.25.67c-.27-.4-.73-.67-1.25-.67C8.67 3.5 8 4.17 8 5v3.5c0 2.21 1.79 4 4 4zM10 6h4v2.5c0 1.1-.9 2-2 2s-2-.9-2-2V6z"
    ></path>
  </svg>
)
